import {
  GET_CODE_LISTING_MANAGEMENT,
  GET_CODE_LISTING_MANAGEMENT_SUCCESS,
  GET_CODE_LISTING_MANAGEMENT_FAILURE,
  GET_SCHOOLNAME_FILTER,
  GET_SCHOOLNAME_FILTER_SUCCESS,
  GET_SCHOOLNAME_FILTER_FAILURE,
} from "../types";

export const getcodelisting = (payload) => ({
  type: GET_CODE_LISTING_MANAGEMENT,
  payload,
});

export const getcodelistingSuccess = (payload) => ({
  type: GET_CODE_LISTING_MANAGEMENT_SUCCESS,
  payload,
});

export const getcodelistingFailure = (payload) => ({
  type: GET_CODE_LISTING_MANAGEMENT_FAILURE,
  payload,
});

export const getschoolname = (payload) => ({
  type: GET_SCHOOLNAME_FILTER,
  payload,
});
export const getschoolnameSuccess = (payload) => ({
  type: GET_SCHOOLNAME_FILTER_SUCCESS,
  payload,
});

export const getschoolnameFailure = (payload) => ({
  type: GET_SCHOOLNAME_FILTER_FAILURE,
  payload,
});
